//import React from 'react';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    getCleaningtasks, getCleaningtypes, getView
} from "../dbconnector/connector";
import { setErrorMessage, setMessage } from "../tools/errorhandling";
import EmployeeRoosterNode from '../customNodes/EmployeeRoosterNode';
import Button from 'react-bootstrap/Button';
import { confirmAlert } from 'react-confirm-alert';
import { use } from 'react';
import { useMemo } from 'react';
import moment from 'moment';
import logo from "../invoices/logo.png"
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import React, { Component, PropTypes } from 'react';
import { TbSend2 } from 'react-icons/tb';
import { BsFillSave2Fill } from 'react-icons/bs';

const DagstaatNode = ({ rights, hotel, hotelid, t, datum }) => {

    const [generalservicestasksarray, setgeneralservicestasksarray] = useState([]);
    const [generalservicesextratimearray, setgeneralservicesextratimearray] = useState([]);
    const [payedtasksarray, setpayedtasksarray] = useState([]);
    const [generalservicestasks, setgeneralservicestasks] = useState([]);
    const [cleaningtypearray, setcleaningtypearray] = useState([]);
    const [CleaningTypes, setCleaningTypes] = useState({});
    const [dagstaten, setDagstaten] = useState([]);
    const [dagstaten_payedtasks, setDagstaten_payedtasks] = useState([]);
    const [dagstaten_comments, setDagstaten_comments] = useState([]);
    const [dagstaten_commentsarray, setDagstaten_commentsarray] = useState([]);


    useEffect(() => {

        GetDagStaten();
        GetDagStaten_payedtasks();
        Getgeneralservicestasks();
        Get_comments_assignments();
        Getcleaningtypes()
    }, []);

    useEffect(() => {
        if (generalservicestasks.length > 0) {
            const types = generalservicestasks
            const array = []
            setpayedtasksarray([]);
            setgeneralservicestasksarray([]);
            setgeneralservicesextratimearray([]);
            types.forEach((item, index) => {
                let aantal = 0
                if (dagstaten_payedtasks.length > 0) {
                    dagstaten_payedtasks.forEach((taak, index) => {
                        if (taak.cleaningtype_Id !== -1) {
                            if (taak.multiple !== "{}") {
                                let multipletasks = JSON.parse(taak.multiple)
                                const filteredkeys = Object.keys(multipletasks)
                                filteredkeys.forEach((key) => {
                                    if (item.Id === Number(key)) {
                                        aantal = Number(multipletasks[key]) + aantal
                                    }
                                })
                            }
                            else if (taak.tasks !== "") {
                                if (item.Id === Number(taak.tasks)) {
                                    aantal = 1 + aantal
                                }
                            }
                        }
                    })
                }
                    setpayedtasksarray(pre => [...pre,
                    <div className={hotelcss.dagstaat_tablerow} >
                        <div className={hotelcss.celborderL}>{item.taskDescription}</div>
                        <div className={hotelcss.celborderR}>{aantal}</div>
                    </div>

                    ])

            })
            let adaantal = 0
            let aduren = 0
            types.forEach((item, index) => {
                if (dagstaten_payedtasks.length > 0) {
                    dagstaten_payedtasks.forEach((taak, index) => {
                        if (taak.cleaningtype_Id === -1) {
                            if (taak.multiple !== "{}") {
                                let multipletasks = JSON.parse(taak.multiple)
                                const filteredkeys = Object.keys(multipletasks)
                                filteredkeys.forEach((key) => {
                                    if (item.Id === Number(key)) {
                                        adaantal = Number(multipletasks[key]) + adaantal
                                    }
                                })
                            }
                            else if (taak.tasks !== "") {
                                if (item.Id === Number(taak.tasks)) {
                                    adaantal = 1 + adaantal
                                }
                            }
                            if (taak.extratime > 0) {
                                aduren = aduren + taak.extratime
                            }
                        }
                    })
                }
            })
            setgeneralservicestasksarray(pre => [...pre,
            <div className={hotelcss.dagstaat_tablerow} >
                <div className={hotelcss.celborderL}>Algemene dienst - extra taken</div>
                <div className={hotelcss.celborderR}>{adaantal}</div>
            </div>
            ])
            setgeneralservicesextratimearray(pre => [...pre,
            <div className={hotelcss.dagstaat_tablerow} >
                <div className={hotelcss.celborderL}>Algemene dienst - uren</div>
                <div className={hotelcss.celborderR}>{aduren / 60}</div>
            </div>

            ])
        }
    }, [generalservicestasks, dagstaten_payedtasks]);

    useEffect(() => {
        setDagstaten_commentsarray([]);
        let comments = ""
       //console.log("dagstaten_comments: ", dagstaten_comments)
        if (dagstaten_comments.length > 0) {
           //console.log("dagstaten_comments: ", dagstaten_comments)
            const types = dagstaten_comments
            comments = "";
            types.forEach((item, index) => {
                comments = comments + " kamer " + item.roomnumber + " : " + item.description + "\n"
            })
            setDagstaten_commentsarray(pre => [...pre,
            <textarea className={hotelcss.textarea_Dagstaat}>
                {comments}
            </textarea>
            ])
        }

    }, [dagstaten_comments]);

    useEffect(() => {
        let blijvers = 0;
        let vertrekkers = 0;
        if (dagstaten.length > 0) {
            dagstaten.forEach((item, index) => {
                blijvers = item.blijvers
                vertrekkers = item.vertrekkers
            })
        }
        if (CleaningTypes.length > 0 && dagstaten.length > 0) {
            const types = CleaningTypes
            const array = []
            //console.log("types loaded : ", types)
            setcleaningtypearray([]);
            let type0done = false;
            let type1done = false;
            let type2done = false;
            let type3done = false;
            let type4done = false;
            let type5done = false;
            types.forEach((item, index) => {
                let firstword = t('Aantal ')
                let typedesc = t('Blijvers');

                if (item.type === 0 && type0done === false) {
                    typedesc = t('Blijvers');

                    setcleaningtypearray(pre => [...pre,
                    <div id={"taak" + index} className={hotelcss.dagstaat_tablerow} >
                        <div id={"taak_0" + index} className={hotelcss.celborderL}>{firstword} {typedesc}</div>
                        <div id={"taak_1" + index} className={hotelcss.celborderR}>{blijvers}</div>
                    </div>
                    ])
                    type0done = true
                }


                if (item.type === 1 && type1done === false) {
                    typedesc = t('Vertrekkers');

                    setcleaningtypearray(pre => [...pre,
                    <div id={"taak" + index} className={hotelcss.dagstaat_tablerow} >
                        <div id={"taak_0" + index} className={hotelcss.celborderL}>{firstword} {typedesc}</div>
                        <div id={"taak_1" + index} className={hotelcss.celborderR}>{vertrekkers}</div>
                    </div>
                    ])
                    type1done = true
                }
                if (item.type === 2 && type2done === false) {
                    typedesc = t('Flitskamers');

                    setcleaningtypearray(pre => [...pre,
                    <div id={"taak" + index} className={hotelcss.dagstaat_tablerow} >
                        <div id={"taak_0" + index} className={hotelcss.celborderL}>{firstword} {typedesc}</div>
                        <div id={"taak_1" + index} className={hotelcss.celborderR}>&nbsp;</div>
                    </div>
                    ])
                    type2done = true
                }
                if (item.type === 3 && type3done === false) {
                    typedesc = t("dailyclean");
                    setcleaningtypearray(pre => [...pre,
                    <div id={"taak" + index} className={hotelcss.dagstaat_tablerow} >
                        <div id={"taak_0" + index} className={hotelcss.celborderL}>{firstword} {typedesc}</div>
                        <div id={"taak_1" + index} className={hotelcss.celborderR}>&nbsp;</div>
                    </div>

                    ])
                    type3done = true
                }
                if (item.type === 4 && type4done === false) {
                    typedesc = t("weeklyClean");

                    setcleaningtypearray(pre => [...pre,
                    <div id={"taak" + index} className={hotelcss.dagstaat_tablerow} >
                        <div id={"taak_0" + index} className={hotelcss.celborderL}>{firstword} {typedesc}</div>
                        <div id={"taak_1" + index} className={hotelcss.celborderR}>&nbsp;</div>
                    </div>

                    ])
                    type4done = true
                }
                if (item.type === 5 && type5done === false) {
                    typedesc = t("finalClean");

                    setcleaningtypearray(pre => [...pre,
                    <div id={"taak" + index} className={hotelcss.dagstaat_tablerow} >
                        <div id={"taak_0" + index} className={hotelcss.celborderL}>{firstword} {typedesc}</div>
                        <div id={"taak_1" + index} className={hotelcss.celborderR}>&nbsp;</div>
                    </div>

                    ])
                    type5done = true
                }


            })
        }

    }, [CleaningTypes, dagstaten]);

    const GetDagStaten = () => {
        if (hotel.Hotel_ID) {
            const fields = '["hotel_id", "creationdate"]';
            const values = `[${hotelid}, "${datum} 00:00:00"]`;
            setDagstaten([])
            getView("dagstaten", fields, values).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setDagstaten(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const GetDagStaten_payedtasks = () => {
        if (hotel.Hotel_ID) {
            setDagstaten_payedtasks([])
            const fields = '["hotel_id", "creationdate"]';
            const values = `[${hotelid}, "${datum}"]`;
           //console.log("fields: ", fields)
           //console.log("values: ", values)
            getView("dagstaten_hotel_day_payedtasks", fields, values).then(res => {
                if (res.status === 200) {

                    res.json().then(body => {
                       //console.log("body: ", body)
                        setDagstaten_payedtasks(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const Getgeneralservicestasks = () => {
        if (hotel.Hotel_ID) {
            getCleaningtasks(hotel.Hotel_ID, 1).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setgeneralservicestasks(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const Getcleaningtypes = () => {
        if (hotel.Hotel_ID) {
            getCleaningtypes(hotel.Hotel_ID).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setCleaningTypes(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText, "failed to refresh cleaningtypes")
                }
            })
        }
    }

    const Get_comments_assignments = () => {
        if (hotel.Hotel_ID) {
            setDagstaten_comments([])
            const fields = '["hotel_id", "creationdate"]';
            const values = `[${hotelid}, "${datum}"]`;
           //console.log("fields: ", fields)
           //console.log("values: ", values)
            getView("comments_assigments", fields, values).then(res => {
                if (res.status === 200) {

                    res.json().then(body => {
                        setDagstaten_comments(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const senddagstaat = () => {
        // const input = document.getElementById('roosterform');
        ////console.log(input)
        // html2canvas(input).then((canvas) => {
        //     const imgData = canvas.toDataURL('image/png');
        //     const pdf = new jsPDF();
        //     pdf.addImage(imgData, 'JPEG', 0, 0);
        //     // pdf.output('dataurlnewwindow');
        //     pdf.save("download.pdf");
        // })
       //console.log("height :", document.getElementById('printcanvas').clientHeight)
        //console.log("width :", document.getElementById('printcanvas').clientWidth)

        htmlToImage.toPng(document.getElementById('printcanvas'), { quality: 1 })
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'my-image-name.jpeg';
                const pdf = new jsPDF("p", "mm", "a4");

                var width = pdf.internal.pageSize.getWidth();
                var height = pdf.internal.pageSize.getHeight();
                if (document.getElementById('printcanvas').clientHeight > 891)
                {
                    width = 0
                }
                pdf.addImage(dataUrl, 'PNG', 0, 0, width, height);
                pdf.save("download.pdf");
            });
    }

    return (
        <>
            <form id="roosterform" >
                {/* <div className="tabpanel"> */}
                    <div id="printcanvas" className="printcanvas">
                        <div key="headertabled0" id="headertabled" className={hotelcss.dagstaat_table} >
                            <img className={hotelcss.logo}
                                src={logo}
                            /><div className={hotelcss.dagstaatTitle}><p >{t('DAGSTAAT')}</p><TbSend2  onClick={senddagstaat} /><BsFillSave2Fill/></div>
                            <div className={hotelcss.celborderL}>{t('Naam Hotel')}</div><div className={hotelcss.celborderR}>{hotel.Name}</div>
                            <div className={hotelcss.celborderL}>{t('Datum')}</div><div className={hotelcss.celborderR}>{moment(new Date(datum).toLocaleDateString('en-CA')).format("DD-MMM-YYYY")}</div>
                            <div className={hotelcss.celborderTopLine}>Omschrijving</div><div className={hotelcss.celborderTopLine}>Aantal</div>
                        </div>
                        {cleaningtypearray}
                         <div key="headertabled0" id="headertabled" className={hotelcss.dagstaat_tablerow_2} >
                            <div className={hotelcss.celborderTopLine}>Extra betalende taken</div>
                        </div>
                        {payedtasksarray}
                        {generalservicestasksarray}

                        <div key="headertabled0" id="headertabled" className={hotelcss.dagstaat_tablerow} >
                            <div className={hotelcss.celborderTopLine}>&nbsp;</div><div className={hotelcss.celborderTopLine}>Uren</div>
                        </div>
                        {generalservicesextratimearray}

                        <div key="headertabled0" id="headertabled" className={hotelcss.dagstaat_tablerow_2} >
                            <div className={hotelcss.celborderTopLine}>Technische gebreken</div>
                            <div>
                                <textarea className={hotelcss.textarea_Dagstaat} >Geen technische gebreken
                                </textarea></div>

                        </div>

                        <div key="headertabled0" id="headertabled" className={hotelcss.dagstaat_tablerow_2} >
                            <div className={hotelcss.celborderTopLine}>Opmerkingen</div>
                            <div style={dagstaten_commentsarray.length > 0 ? { display: 'none' } : { display: 'block' }}>
                                <textarea className={hotelcss.textarea_Dagstaat}>Geen opmerkingen</textarea></div>
                            {dagstaten_commentsarray}
                        </div>

                        <div key="headertabled0" id="headertabled" className={hotelcss.dagstaat_tablerow} >
                            <div className={hotelcss.celborderTopLine}>&nbsp;</div><div className={hotelcss.celborderTopLine}>&nbsp;</div>
                        </div>

                        <div key="headertabled0" id="headertabled" className={hotelcss.dagstaat_tablerow_3} >
                            <div className={hotelcss.celSignature}>Voor akkoord</div>
                            <div className={hotelcss.celSignature}>Voor akkoord</div>
                            <div className={hotelcss.celSignature}>{hotel.Name}</div>
                            <div className={hotelcss.celSignature}>SHC Hotelservices BV</div>
                        </div>

                        <div key="headertabled0" id="headertabled" className={hotelcss.dagstaat_tablerow_4} >
                            <div className={hotelcss.celSignature}>&nbsp;</div><div className={hotelcss.celSignature}>&nbsp;</div><div className={hotelcss.celSignature}>&nbsp;</div>
                            <div className={hotelcss.celSignature}>&nbsp;</div><div className={hotelcss.celSignature}>&nbsp;</div><div className={hotelcss.celSignature}>&nbsp;</div>
                            <div className={hotelcss.celSignatureLine}></div><div className={hotelcss.celSignature}>&nbsp;</div><div className={hotelcss.celSignatureLine}></div>
                        </div>

                        <div key="headertabled0" id="headertabled" className={hotelcss.dagstaat_table_bottom} >
                            <div className={hotelcss.celborderTopLine}>&nbsp;</div><div className={hotelcss.celborderTopLine}>&nbsp;</div>
                        </div>
                    </div>
                    {/* <div id="saveDiv" className="two_Buttons">
                        <Button id="saveButton" className='Savebutton' onClick={senddagstaat}>{t('Verstuur naar')} {hotel.Name}</Button>
                        <Button id="cancelButton" className='Savebutton' >{t('Bewaar')}</Button>
                    </div> */}
                {/* </div> */}
            </form>
        </>
    );
}


export default DagstaatNode;
